// utilities
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "modifyImageInfo", {
    enumerable: true,
    get: function() {
        return modifyImageInfo;
    }
});
const _checkImageInfo = /*#__PURE__*/ _interop_require_default(require("./checkImageInfo.js"));
const _enums = require("../enums");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const DEFAULT_RETURN = {
    modifiedImageInfo: {},
    changedKeys: []
};
function modifyThermalImageInfo(prev, next, frameIndex = 0) {
    const { info = {}, basicPresentationFlags = {}, irPaletteSetup = {} } = next;
    const prevFrameInfoData = Array.isArray(prev) ? prev[frameIndex] : prev;
    // next payload -->
    const nextPayload = _object_spread_props(_object_spread({}, prevFrameInfoData, info), {
        basicPresentationFlags: _object_spread({}, prevFrameInfoData.basicPresentationFlags, basicPresentationFlags),
        irPaletteSetup: _object_spread({}, prevFrameInfoData.irPaletteSetup, irPaletteSetup)
    });
    // IMAGE INFO -->
    let result;
    if (Array.isArray(prev)) {
        // is2-universal -->
        result = [
            ...prev
        ];
        result[frameIndex] = nextPayload;
    } else {
        // legacy -->
        result = nextPayload;
    }
    return result;
}
function modifyMARKERS(prev = {}, next = {}) {
    const { markers = {} } = next;
    const result = _object_spread_props(_object_spread({}, prev), {
        STANDARD: _object_spread({}, prev.STANDARD, (markers === null || markers === void 0 ? void 0 : markers.STANDARD) || {}),
        USERDEFINED: _object_spread({}, prev.USERDEFINED, (markers === null || markers === void 0 ? void 0 : markers.USERDEFINED) || {})
    });
    return result;
}
function modifyPHOTONOTES(prev = [], next = {}) {
    const { OCR_TEXT } = _enums.ValidSettings;
    const { photonotes: { ocrText = [] } = {} } = next;
    const result = prev.map((photonote, index)=>{
        var _ocrText_index;
        return _object_spread_props(_object_spread({}, photonote), {
            [OCR_TEXT]: (_ocrText_index = ocrText[index]) !== null && _ocrText_index !== void 0 ? _ocrText_index : ""
        });
    });
    return result;
}
function modifyIRVIEWER(prev = {}, next = {}) {
    const { irviewer = {} } = next;
    const result = _object_spread({}, prev, irviewer);
    return result;
}
function modifyTEXTNOTES(prev = {}, next = {}) {
    const { TEXTNOTES } = _enums.ValidSettings;
    const { textnotes = {} } = next;
    const result = textnotes[TEXTNOTES] || prev;
    return result;
}
function modifyImageInfo(settings = {}, imageInfo = {}, frameIndex = 0) {
    const { THERMAL_IMAGE_INFO_DATA, MARKERS, IRVIEWER, PHOTONOTES, TEXTNOTES } = _enums.ImageInfoKeys;
    if (!imageInfo || !Object.keys(imageInfo).length) return DEFAULT_RETURN;
    const { nextAttrs = {}, changedKeys = [] } = (0, _checkImageInfo.default)(settings, imageInfo, frameIndex);
    if (changedKeys.length < 1) return DEFAULT_RETURN;
    const { [THERMAL_IMAGE_INFO_DATA]: prevInfoData, [IRVIEWER]: prevIRVIEWER = {}, [MARKERS]: prevMARKERS = {}, [TEXTNOTES]: prevNotes = [], [PHOTONOTES]: prevPhotonotes = [] } = imageInfo;
    const modifiedImageInfo = _object_spread_props(_object_spread({}, imageInfo), {
        [THERMAL_IMAGE_INFO_DATA]: modifyThermalImageInfo(prevInfoData, nextAttrs, frameIndex),
        [IRVIEWER]: modifyIRVIEWER(prevIRVIEWER, nextAttrs),
        [MARKERS]: modifyMARKERS(prevMARKERS, nextAttrs)
    });
    if (changedKeys.includes(_enums.ValidSettings.OCR_TEXT)) {
        modifiedImageInfo[PHOTONOTES] = modifyPHOTONOTES(prevPhotonotes, nextAttrs);
    }
    if (changedKeys.includes(_enums.ValidSettings.TEXTNOTES)) {
        modifiedImageInfo[TEXTNOTES] = modifyTEXTNOTES(prevNotes, nextAttrs);
    }
    return {
        modifiedImageInfo,
        changedKeys
    };
}
